// services/fileService.js
import apiClient from "./axiosInterceptor";

// 1) Upload the file (multipart) -> returns filePath
export const uploadFile = async ({
  file,
  processName,
  subProcess,
  fileName,
}, options = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("fileName", fileName || file?.name || "");
  fd.append("fileTypeName", processName || "processName");
  fd.append("subProcess", subProcess || "subProcess");

  try {
    const res = await apiClient.post(
      `/data_models_machine_learning/upload/blob`,
      fd,
      options
    );
    return {
      ...res.data,
      filePath: res.data.filePath || res.data.file_path,
    };
  } catch (error) {
    console.error("Upload failed with proxy, trying direct HTTP:", error);
    throw error;
  }
};

// 2) Call the second API using the returned filePath
export const processUploadedFile = async (params = {}) => {
  const rawName = params.file_name || params.filePath || "";
  const file_name =
    typeof rawName === "string" ? rawName.split(/[/\\]/).pop() : "";
  try {
    const res = await apiClient.post(
      `/data_models_machine_learning/metadata`,
      { file_name },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
    );
    return res?.data?.message;
  } catch (error) {
    console.error("Process error:", error);
    throw error;
  }
};


export async function generativeEngineInsightsResult({
  file_name,
}) {

  try {
    const res = await apiClient.post(`/generative_engine/query`, {
      file_name: file_name,
      question: "Review this dataset as an internal auditor. Identify the top 5 material risks, quantify their financial exposure, explain why they matter, and recommend specific actions for management. Avoid technical jargon and present results in plain English, Avoid Suggestions and Recommendations/Recommendet actions.",
      return_table: false,
      debug: false,
      max_steps: 6,
      mode: "normal",
      query_request_type: "insights",
    });
    return res?.data?.answer_markdown;
  } catch (error) {
    console.error("analysis error:", error);
    throw error;
  }
}


// 3) Calln the third API to apply models
export async function applyModels({
  file_name,
  models,
  dep_variable,
  groupby_columns,
}, options = {}) {

  try {
    const res = await apiClient.post(
      `/data_models_machine_learning/anomalies_new`,
      {
        file_name,
        models,
        dep_variable,
        groupby_columns,
      },
      options
    );
    return res.data;
  } catch (error) {
    console.error("analysis error:", error);
    throw error;
  }
}
